import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// graphQL
import gql from 'graphql-tag';
import StatsPeriod from 'components/common/StatsPeriod/StatsPeriod';
import Stats from 'components/common/Stats/Stats';

export const NEW_USERS_QUERY = gql`
  query newUsers($minDate: Date!, $maxDate: Date!) {
    registeredUsersStats(minDate: $minDate, maxDate: $maxDate) {
      total
    }
  }
`;

const UserStatsContainer = ({ t }) => (
  <StatsPeriod query={NEW_USERS_QUERY}>
    {({ data, updateData }) => (
      <Stats
        title={t('dashboard.new_users')}
        data={
          data && data.registeredUsersStats
            ? data.registeredUsersStats.total
            : 0
        }
        statsUpdate={date => updateData(date)}
      />
    )}
  </StatsPeriod>
);

UserStatsContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(UserStatsContainer);
